import { AppHeading5 } from 'components/shared/AppHeading';
import MarkdownComponent from 'components/shared/MarkdownComponent';
import { useState } from 'react';
import {
  StyledLink,
  StyledTab,
  StyledTabContent,
  StyledTabNumber,
  StyledTabs,
  StyledTabSystem
} from './JuniorsKit.styled';

type ContentProps = {
  content?: any[];
  links?: any[];
};

const JuniorsKitTabs: React.FC<ContentProps> = ({ content, links }) => {
  const [tabActive, setTabActive] = useState(undefined);

  const sortedContent = content?.sort(
    (a, b) => a.attributes.order - b.attributes.order
  );
  const defaultContentActive = sortedContent
    ? Object.values(sortedContent)[0]
    : undefined;
  const defaultTabActive = defaultContentActive
    ? defaultContentActive.id
    : undefined;
  const selectedTab = tabActive
    ? content?.find((e) => e.id === tabActive)
    : defaultContentActive;

  const sortedLinks = links?.sort(
    (a, b) => a.attributes.order - b.attributes.order
  );

  return (
    <StyledTabSystem>
      <StyledTabs>
        {sortedContent?.map(
          ({ id, attributes }) =>
            attributes.order > 0 && (
              <StyledTab
                key={id}
                type="button"
                onClick={() => setTabActive(id)}
                className={
                  tabActive === id ||
                  (tabActive === undefined && defaultTabActive === id)
                    ? 'is-active'
                    : ''
                }
              >
                {attributes.order < 10 && (
                  <StyledTabNumber>0{attributes.order}</StyledTabNumber>
                )}
                {attributes.order >= 10 && (
                  <StyledTabNumber>{attributes.order}</StyledTabNumber>
                )}
                {attributes.name}
              </StyledTab>
            )
        )}
      </StyledTabs>
      {selectedTab && (
        <StyledTabContent>
          <img
            src={selectedTab?.attributes?.image.data.attributes.url}
            alt=""
          />
          <AppHeading5>{selectedTab?.attributes?.name}</AppHeading5>
          <MarkdownComponent content={selectedTab?.attributes?.description} />
          <div>
            {sortedLinks?.map(
              ({ id, attributes }) =>
                attributes.order > 0 &&
                attributes.helping_co_section.data &&
                (tabActive
                  ? attributes.helping_co_section.data.id === tabActive
                  : attributes.helping_co_section.data.id ===
                    defaultTabActive) && (
                  <StyledLink key={id} href={attributes.link} target="_blank">
                    {attributes.name}
                  </StyledLink>
                )
            )}
          </div>
        </StyledTabContent>
      )}
    </StyledTabSystem>
  );
};

export default JuniorsKitTabs;
